<template>
  <!-- Seaded -> Kliendid uues kujunduses: the new look. Off, the old table. -->
  <list-plate v-if="plate" />
  <loading-content v-else :loading="loading">
    <h1>Kliendid</h1>
    <v-data-table-server
      class="table"
      :headers="headers"
      :items="clients"
      :loading="loading"
      :items-length="count"
      v-model:items-per-page="itemsPerPage"
      v-model:page="page"
      :items-per-page-options="itemsPerPageOptions"
      density="compact"
    >
      <template v-slot:[`body.prepend`]="{ columns }">
        <tr class="d-flex flex-column d-sm-table-row search">
          <td>
            <v-text-field v-model="search.fullName" type="text" label="Nimi" v-bind="searchFieldProps" />
          </td>
          <td>
            <v-text-field v-model="search.phone" type="text" label="Telefon" v-bind="searchFieldProps" />
          </td>
          <td>
            <v-text-field v-model="search.email" type="text" label="Epost" v-bind="searchFieldProps" />
          </td>
          <td>
            <v-text-field v-model="search.postcode" type="text" label="Postiinndeks" v-bind="searchFieldProps" />
          </td>
          <td class="d-none d-sm-table-cell"  :colspan="columns.length - 4"></td>
        </tr>
      </template>
      <template v-slot:[`item.fullName`]="{ item }">
        <router-link
          :to="{name: 'client/view/info',
          params: { clientId: item.id }}"
          :class="{'text-red': item.problematic}"
          :title="item.problematic && item.problematicNote || undefined"
        >{{item.fullName}}</router-link>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn v-if="office" color="primary" @click="edit(item)" size="x-small">
          Muuda
        </v-btn>
      </template>
    </v-data-table-server>
  </loading-content>
</template>

<script>
import api from '@/api'
import listMixin from '@/plugins/listMixin'
import { mapGetters, mapState } from 'vuex'
import ListPlate from './ListPlate.vue'

const types = {
  private: 1,
  company: 2
}

export default {
  components: { ListPlate },
  mixins: [ listMixin ],
  data () {
    return {
      listViewConf: {
        apiMethod: api.getClients,
        itemKey: 'clients'
      },
      types,
      clients: [],
      search: {
        fullName: this.$route.query.fullName || '',
        phone:  this.$route.query.phone || '',
        email:  this.$route.query.email || '',
        postcode: this.$route.query.postcode || ''
      },
      headers: [{
        title: 'Nimi',
        align: 'start',
        value: 'fullName',
        sortable: false
      }, {
        title: 'Telefon',
        align: 'start',
        value: 'phone',
        sortable: false
      }, {
        title: 'Epost',
        align: 'start',
        value: 'email',
        sortable: false
      }, {
        title: 'Postiindeks',
        align: 'start',
        value: 'postcode',
        sortable: false
      }, {
        title: '',
        value: 'actions',
        sortable: false,
        align: 'end',
      }]
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'isSecretary']),
    // Muuda is the office's. A technician has the list to read (2026-10-14).
    office () {
      return this.isAdmin || this.isSecretary
    },
    ...mapState(['features']),
    plate () {
      return !!(this.features && this.features.clientPlate)
    }
  },
  methods: {
    // The new look loads its own rows; the old table's fetch would only be
    // thrown away.
    refresh () {
      if (this.plate) return
      return listMixin.methods.refresh.call(this)
    },
    edit ({ id }) {
      this.$router.push({ name: 'client/edit', params: { clientId: id }})
    }
  }
}
</script>

<style lang="scss">
.table {
  .search {
    td {
      height: auto !important;
      padding: 8px !important;
    }
  }
}
</style>